import NoteActions from 'actions/NoteActions';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as BioentityActions from 'inventory/BioentityActions';
import * as navigation from 'Navigation';
import deepCopyNote from 'notebook/notes/deepCopyNote';
import APIUtil from 'util/APIUtil';

class MetadataTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Metadata',
      closeable: false,
      preferenceKey: 'metadata',
    };
  }

  initialize(): void {
    this.loadInventoryFileInfo();
    this.loadMixtureInstructions();
  }

  loadInventoryFileInfo(): void {
    BioentityActions.load(this.get('model').id, {
      bioentityAliasInfos: this.get('model').initialBioentityAliasInfos(),
    });
  }

  loadMixtureInstructions(): void {
    const bioentityModel = this.get('model');
    const modelIsMixture = APIUtil.apiIdToType(bioentityModel.id) === ModelTypeConstants.MIXTURE;
    if (modelIsMixture) {
      const instructions = bioentityModel.getInstructions();
      if (instructions) {
        NoteActions.load(instructions.id, deepCopyNote(instructions.noteJson));
      }
    }
  }
}

export default MetadataTabState;
